import React from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Card, Btn } from "@/components/ui-kit";
import { ROLE_LABELS, fmtDate } from "@/lib/constants";
import { MailCheck } from "lucide-react";

export function PendingInvites({ invites, onDone }) {
  if (!invites.length) return null;
  const revoke = async (inv) => {
    try { await api.post(`/users/invites/${inv.id}/revoke`); toast.success("Invite revoked"); onDone(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  return (
    <Card className="p-3" data-testid="pending-invites">
      <div className="mb-2 flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest text-primary"><MailCheck size={13} /> Invites sent, not yet accepted ({invites.length})</div>
      <div className="space-y-1.5">
        {invites.map((i) => (
          <div key={i.id} className="flex flex-wrap items-center gap-3 rounded border border-border px-3 py-2 text-sm" data-testid={`invite-row-${i.id}`}>
            <div className="min-w-0 flex-1"><span className="font-medium">{i.full_name}</span> <span className="font-mono text-xs text-muted-foreground">{i.email} · {ROLE_LABELS[i.role]} · expires {fmtDate(i.expires_at)}</span></div>
            <Btn size="sm" variant="outline" onClick={() => revoke(i)} data-testid={`revoke-invite-${i.id}`}>Revoke</Btn>
          </div>
        ))}
      </div>
    </Card>
  );
}
